import { render, staticRenderFns } from "./UserResetPassword.vue?vue&type=template&id=d2e50ae8&"
import script from "./UserResetPassword.vue?vue&type=script&lang=js&"
export * from "./UserResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./UserResetPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports